import React from 'react';
import {
    ETransactionType,
    TTransactions,
} from '../../../../../../types/entities/transactions';
import WithdrawInfo from './withdraw';
import PulsaInfo from './pulsa';
import TopUpInfo from './top-up';

const getInfoCompByTransType = (curData: TTransactions) => {
    switch (curData.type) {
        case ETransactionType.PULSA:
            return PulsaInfo;
        case ETransactionType.WITHDRAW:
            return WithdrawInfo;
        case ETransactionType.TOP_UP:
            return TopUpInfo;
        default:
            return () => <></>;
    }
};

export default getInfoCompByTransType;
